import script from "./DownloadApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadApp.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadApp.vue?vue&type=style&index=0&id=265ba324&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265ba324"]])

export default __exports__